export default __webpack_public_path__ + "static/media/Sheets.6ca487d9.svg";